import { InjectionToken } from '@angular/core';
import type OktaAuth from '@okta/okta-auth-js';

/** Injectable Okta client so tests can substitute a fake without touching the network. */
export const OKTA_AUTH = new InjectionToken<OktaAuth>('OKTA_AUTH');
